import { Popover, Typography } from '@mui/material'

export default function EntryPopover({...params}){
    let value = params.value
    let popoverAnchor = params.popoverAnchor 
    let closePopover = params.closePopover

    let isOpen = (popoverAnchor !== null)

    return (
        <Popover open={isOpen} anchorEl={popoverAnchor} onClose={closePopover} anchorOrigin={{vertical: 'bottom', horizontal: 'left' }}>
            <Typography>{value}</Typography>
        </Popover>
    )
}
